import React from "react";

export default function StartAndStopIcon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 19.5938C15.7462 19.5938 19.5938 15.7462 19.5938 11C19.5938 6.2538 15.7462 2.40625 11 2.40625C6.2538 2.40625 2.40625 6.2538 2.40625 11C2.40625 15.7462 6.2538 19.5938 11 19.5938Z"
        fill="white"
      />
      <path
        d="M11 20C6.03733 20 2 16.0455 2 11.1847C2 7.65135 4.14467 4.46987 7.46387 3.07927C7.9716 2.86665 8.55933 3.09729 8.77653 3.5946C8.99373 4.09192 8.75813 4.66759 8.2504 4.88034C5.6684 5.96207 4 8.43677 4 11.1847C4 14.9652 7.14013 18.041 11 18.041C14.8599 18.041 18 14.9652 18 11.1847C18 8.43677 16.3316 5.96207 13.7496 4.88034C13.2419 4.66759 13.0063 4.09192 13.2235 3.5946C13.4407 3.09703 14.0283 2.86639 14.5361 3.07927C17.8553 4.46987 20 7.65148 20 11.1847C20 16.0455 15.9627 20 11 20Z"
        fill="#126E83"
      />
      <path
        d="M11 10C10.4477 10 10 9.44217 10 8.75374V2.24626C10 1.55783 10.4477 1 11 1C11.5523 1 12 1.55783 12 2.24626V8.75374C12 9.44217 11.5523 10 11 10Z"
        fill="#126E83"
      />
    </svg>
  );
}
